import type WebModel from '../models/WebModel'
import Lazyable from '../lazyable/Lazyable'
import Logger from '../helpers/Logger'

const DISABLE_TIME = 4000
const JTRSelectors = [
  '.wprm-recipe-jump',
  '.tasty-recipes-jump-link',
  '.mv-create-jtr',
  '.jump_to_get_recipe_button_btn'
]

export default class JumpToRecipe {
  constructor(readonly model: WebModel) {
    const jumpButtons = document.querySelectorAll(JTRSelectors.join(', '))

    // For each jump button we find, add a click listener that disables
    // content and video loading for a few seconds.
    jumpButtons.forEach((button) => {
      button.addEventListener('click', () => {
        Logger.debug(
          `JTR click detected.  Disalbling content waypoints and video insertion for ${DISABLE_TIME} ms`
        )
        Lazyable.disableContentWaypointsFor(DISABLE_TIME)
      })
    })
  }
}
